module.exports = __webpack_public_path__ + "media/Gs.dd702840.wav";